





























import { Vue, Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import AddDialog from '@/components/dialogs/AddDialog.vue'
import ListSectionModel from '@/models/navigation/listSectionModel.ts'
import NavigationModel from '@/models/navigation/navigationModel.ts'
import BasicList from '@/components/lists/BasicList.vue'
import ExtensionModel from '../models/extension/extensionModel'
import apiService from '../services/apiService'
import { UrlType } from '../constants/urlType'
import { Dictionary } from 'vue-router/types/router'
import ExtensionModule from '../store/extensionModule'
import { getModule } from 'vuex-module-decorators'
import Validation from '@/mixins/validation.ts'

const extensionModule = getModule(ExtensionModule)

@Component({
  components: {
    BasicList,
    AddDialog
  }
})
export default class ExtensionsAdmin extends Validation {
  private extensions: ExtensionModel[] = []
  private extension: ExtensionModel = new ExtensionModel()
  private dialog: boolean = false
  private isEdit: boolean = false

  get modalTitle() {
    return this.isEdit ? 'Edit Extension' : 'New Extension'
  }

  private async created() {
    this.subscribeToModalOpen()
    this.getExtensions()
  }

  private subscribeToModalOpen(): void {
    this.$root.$on('openNavbarModal', () => {
      this.dialog = true
    })
  }

  private navigate(item: ExtensionModel) {
    this.$router.push({
      name: 'extension-admin',
      params: { id: item.extensionId }
    })
  }

  private async saveExtension(valid: boolean) {
    if (valid) {
      try {
        if (this.isEdit) {
          await apiService.put<ExtensionModel>(
            UrlType.Extension,
            this.extension.extensionId,
            this.extension
          )
        } else {
          await apiService.post<ExtensionModel>(
            UrlType.Extension,
            this.extension
          )
        }

        this.closeDialog()
        await this.getExtensions()
        this.$root.$emit('refreshExtensions')
      } catch {
        alert('Saving extension failed, please try again')
      }
    }
  }

  private async getExtensions(): Promise<void> {
    this.extensions = await apiService.getAll<ExtensionModel>(UrlType.Extension)
  }

  private editExtension(extension: ExtensionModel) {
    this.extension = Object.assign({}, extension)
    this.isEdit = this.dialog = true
  }

  private async deleteExtension(extension: ExtensionModel): Promise<void> {
    const confirm = window.confirm(
      'Are you sure you would like to delete this extension? Any related data will be deleted.'
    )

    if (confirm) {
      await apiService.delete(UrlType.Extension, extension.extensionId)
      await this.getExtensions()
      this.$root.$emit('refreshExtensions')
    }
  }

  private closeDialog(): void {
    this.isEdit = this.dialog = false
  }
}
